module.exports = __webpack_public_path__ + "img/not-found.0f33fcce.png";